<template>
  <div class="historyDetail">
    <div class="subHead">
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <div
      :class="historyDetail.visitorStatus"
      class="visitStatusBox"
    >{{ historyDetail.visitorStatus | formatStatus }}</div>
    <div v-if="historyDetail.visitorStatus === 'WAITING_VERIFY'" class="content">
      <div>
        <div class="content-title">验证信息</div>
        <div style="background: #fff">
          <div class="content-reason">
            <div class="content-reasonItem">
              <div>验证类型</div>
              <div>{{ historyDetail.beInvite ? '邀约验证' : '身份验证' }}</div>
            </div>
            <div class="content-reasonItem">
              <div>验证码</div>
              <div>{{ historyDetail.beInvite ? historyDetail.askCode : historyDetail.phone }}</div>
            </div>
          </div>
          <div class="tips">
            <p>温馨提示：</p>
            <p>1、刷脸通行仅限来访当天一次进出有效。</p>
            <p v-if="historyDetail.remark">2、{{ historyDetail.remark }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div v-if="historyDetail.visitorStatus === 'WAITING_VISIT' || historyDetail.visitorStatus === 'VISITING'">
        <p class="content-title">凭证信息</p>
        <div style="background: #fff; padding-bottom: 0.2rem">
          <div class="content-reason">
            <p class="content-reasonItem">
              <span>通行方式</span>
              <span>{{ historyDetail.authTypes }}</span>
            </p>
          </div>
          <div
            v-if="!faceImg"
            class="upload_btn"
            @click="showUpload = true"
          >
            <van-icon name="plus" />
          </div>
          <div
            v-else
            class="img_wrap"
          >
            <img :src="baseURL + faceImg">
            <div
              v-show="!uploadSuc"
              class="btn_wrap"
            >
              <van-button
                size="small"
                type="default"
                @click="showUpload = true"
              >
                重新选择
              </van-button>
              <van-button
                size="small"
                type="info"
                @click="handleCommit"
              >提交</van-button>
            </div>
          </div>
          <div v-if="historyDetail.qrCode" class="tips">
            <p>温馨提示：</p>
            <p>1、动态二维码仅限个人使用，3分钟有效，超时后刷新即可使用</p>
            <p v-if="historyDetail.remark">2、{{ historyDetail.remark }}</p>
            <p v-if="historyDetail.description">{{ historyDetail.remark ? '3' : '2' }}、{{ historyDetail.description }}</p>
          </div>
          <div v-else-if="historyDetail.remark" class="tips">
            <p>温馨提示：</p>
            <p>1、{{ historyDetail.remark }}</p>
            <p v-if="historyDetail.description">2、{{ historyDetail.description }}</p>
          </div>
        </div>
      </div>
      <p class="content-title">被访人信息</p>
      <div class="content-detail">
        <p>{{ historyDetail.beVisitStaffName }}</p>
        <p>公司：{{ historyDetail.beVisitCompanyName }}</p>
        <p>大厦：{{ historyDetail.beVisitEdificeName }}</p>
        <p>楼层：{{ historyDetail.beVisitFloorName }}</p>
      </div>
      <div class="content">
        <p class="content-title">来访事由和时间</p>
        <div class="content-reason">
          <p class="content-reasonItem">
            <span>来访事由</span>
            <span>{{ historyDetail.reason }}</span>
          </p>
          <p class="content-reasonItem">
            <span>来访时间</span>
            <span>{{ historyDetail.visitDate }}</span>
          </p>
          <p class="content-reasonItem">
            <span>来访车牌</span>
            <span>{{ historyDetail.carNumber || '无' }}</span>
          </p>
        </div>
      </div>
      <!--      <div v-if="historyDetail.remark" class="stall_tip">{{ `温馨提示：${historyDetail.remark}` }}</div>-->
      <van-button
        v-if="filterMeeting(historyDetail)"
        :disabled="false"
        class="sub_btn success_btn"
        type="primary"
        @click="getMeetingInfo"
      >会议详情</van-button>
      <van-button
        v-show="historyDetail.visitorStatus === 'WAITING_AUDIT' || historyDetail.visitorStatus === 'WAITING_VERIFY' || historyDetail.visitorStatus === 'WAITING_VISIT'"
        :disabled="false"
        class="sub_btn"
        type="info"
        @click="cancleAppointment"
      >取消预约</van-button>
      <!-- 访问中，超时逗留 -->
      <van-button
        v-show="historyDetail.visitorStatus == 'VISITING' || historyDetail.visitorStatus === 'OUTTIME_VISIT'"
        :disabled="false"
        class="sub_btn"
        type="info"
        @click="endVisit"
      >结束访问</van-button>
      <van-dialog
        v-model="showCancleDialog"
        title="温馨提示"
        show-cancel-button
        @confirm="confirmCancle"
      >
        <van-cell-group>
          <van-field v-model.trim="message" rows="1" autosize type="textarea" placeholder="请输入取消原因" />
        </van-cell-group>
      </van-dialog>
      <van-dialog v-model="showEndDialog" title="温馨提示" show-cancel-button @confirm="confirmEnd">
        <van-cell-group style="padding: 0.24rem; line-height: 0.24rem;font-size: 0.13rem;">结束访问将认为您已离开并注销通行权限，是否确认结束访问？</van-cell-group>
      </van-dialog>
    </div>
    <van-popup v-model="showUpload">
      <div class="upload">
        <h5>拍照示例</h5>
        <div class="right_img">
          <img
            alt
            src="../../assets/img/img.png"
          >
        </div>
        <p class="tip_text">
          温馨提示：为保证审核顺利通过，请保持人脸完整清晰，勿用美颜。
        </p>
        <div class="wrong_img">
          <div>
            <img alt src="../../assets/img/img1.png">
            <p>照片模糊</p>
          </div>
          <div>
            <img alt src="../../assets/img/img2.png">
            <p>比例过小</p>
          </div>
          <div>
            <img alt src="../../assets/img/img3.png">
            <p>人脸不完整</p>
          </div>
          <div>
            <img alt src="../../assets/img/img4.png">
            <p>侧脸拍照</p>
          </div>
        </div>
        <van-uploader :after-read="afterRead">
          <van-button type="info" style="display: flex; justify-content: center">
            <svg-icon icon-class="album" />从相册选择
          </van-button>
        </van-uploader>
        <van-uploader
          capture="camera"
          :after-read="afterRead"
        >
          <van-button type="default" style="display: flex; justify-content: center">
            <svg-icon icon-class="picture" />拍照
          </van-button>
        </van-uploader>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { faceAuth, inviteOperate } from '@/api/home';
import fileUtils from '@/utils/fileUtils.js';
import lrz from 'lrz';
import { Step, Steps } from 'vant';
import config from '@/common/config';
import { Upload } from '@/api/user';

export default {
  name: 'FacePassInfo',
  components: {
    [Steps.name]: Steps,
    [Step.name]: Step
  },
  filters: {
    // 过滤访客状态
    formatStatus(val) {
      const statusMap = {
        CANCEL: '已取消',
        WAITING_AUDIT: '待审核',
        WAITING_VERIFY: '待验证',
        AUDIT_FAIL: '未过审',
        WAITING_VISIT: '待到访',
        VISITING: '访问中',
        FINISH: '已完成',
        UNVISIT: '过期未到访',
        OUTTIME_VISIT: '超时逗留',
        AUDIT_PASSED: '已通过',
        AUDIT_REFUSED: '已拒绝',
        OUTTIME_AUDIT: '超时未审核'
      };
      return statusMap[val];
    }
  },
  props: {
    historyDetail: {
      type: Object,
      required: true,
      default() {
        return {
          authTypes: []
        };
      }
    },
    uploadSuc: {
      type: Boolean,
      required: true,
      default() {
        return false;
      }
    },
    faceImg: {
      type: String,
      required: true,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      baseURL:
        process.env.NODE_ENV === 'development'
          ? config.baseUrl.dev
          : config.baseUrl.pro,
      showUpload: false,
      subHead: '详情',
      visitStatus: '访问中',
      showCancleDialog: false,
      message: '',
      qrCodeImgUrl: '',
      showEndDialog: false,
      fromPage: '',
      authTypes: '',
      statusMap: {
        FACE: '人脸识别',
        IC: ' IC卡',
        QR: '二维码',
        '': '无'
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromPage = from.name;
    });
  },
  methods: {
    filterMeeting(historyDetail) {
      const list = [
        'WAITING_AUDIT',
        'WAITING_VERIFY',
        'WAITING_VISIT'
      ];
      return list.includes(historyDetail.visitorStatus) && historyDetail.meetingId;
    },
    getMeetingInfo() {
      this.$router.push({ path: `staffMeetingHistoryDetail/${this.historyDetail.meetingId}-${this.historyDetail.phone}/MY_ATTEND` });
    },
    // 访客预约记录详情
    // 取消预约
    cancleAppointment() {
      this.showCancleDialog = true;
    },
    // 提交取消预约
    confirmCancle() {
      const data = {
        id: this.historyDetail.id,
        reason: this.message,
        status: 'CANCEL'
      };
      inviteOperate(data).then(response => {
        this.showCancleDialog = false;
        if (response.code === 200) {
          // todo 往上调用
          this.$emit('refreshInfo');
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    // 重新预约
    // reappoint() {
    //   sessionStorage.setItem('appointmentInfo', JSON.stringify(this.historyDetail))
    //   this.$router.push({ name: 'home', params: { id: this.historyDetail.id }})
    // },
    // 结束访问
    endVisit() {
      this.showEndDialog = true;
    },
    // 提交结束访问
    confirmEnd() {
      const data = {
        id: this.historyDetail.id,
        reason: '',
        status: 'CANCEL'
      };
      inviteOperate(data).then(response => {
        this.showEndDialog = false;
        if (response.code === 200) {
          // this.getHistoryDetail()
          // TODO 往上调用
          this.$emit('refreshInfo');
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    afterRead(file) {
      fileUtils.getOrientation(file.file).then((orient) => {
        lrz(file.file, { width: 1024 }).then(rst => {
          const fromData = new FormData();
          // 此时可以自行将文件上传至服务器
          let angle = '0';
          switch (orient) { // Orientation 拍摄方向,旋转角度
            case 6: // 顺时针90°
              angle = '90';
              break;
            case 3: // 逆时针90°
              angle = '180';
              break;
            case 8: // 180°
              angle = '270';
              break;
          }
          fromData.append('file', rst.origin);
          fromData.append('angle', angle);
          // this.$toast.loading({
          //   message: '上传中...',
          //   forbidClick: true,
          //   loadingType: 'spinner',
          //   duration: 0
          // });
          Upload(fromData).then(res => {
            this.$toast.clear();
            this.$emit('refreshFaceImg', res.data);
          }).catch(_ => {
            setTimeout(() => { this.$toast.clear(); }, 3000);
          });
          this.showUpload = false;
          this.show = false;
        });
      });
    },
    handleCommit() {
      const data = {
        id: this.historyDetail.id,
        faceImg: this.faceImg
      };
      faceAuth(data).then(res => {
        this.uploadSuc = true;
        this.$toast({
          message: '提交成功!来访当天刷脸通行即可'
        });
        this.$emit('refreshUploadSuc', true);
        // this.headerTip = '提交成功!来访当天刷脸通行即可'
        // this.clickFlag = true
      }).catch(() => {
        // this.clickFlag = true
      });
    }
  }
};
</script>

<style lang="less">
.historyDetail {
  padding-bottom: 0.1rem;
  .content {
    //  padding: 0rem 0.15rem;

    .upload_btn {
      width: 1rem;
      height: 1rem;
      border: 1px dashed #e5e5e5;
      margin: 0.4rem auto;
      display: flex;
      justify-content: center;
      align-items: center;
      .van-icon {
        font-size: 0.2rem;
      }
    }

    .img_wrap {
      margin-top: 0.2rem;
      display: flex;
      justify-content: center;
      flex-direction: column;
      img {
        width: 80%;
        height: auto;
        margin: auto;
      }
    }
    .btn_wrap {
      display: flex;
      justify-content: space-between;
      width: 60%;
      margin: 0.2rem auto 0 auto;
      .van-button {
        border-radius: 0.04rem;
        width: 0.7rem;
      }
    }

    .content-title,
    .visitStatus {
      height: 0.45rem;
      line-height: 0.45rem;
      padding: 0rem 0.15rem;
    }
    .content-detail,
    .content-reason {
      font-size: 0.17rem;
      color: #333;
      background: #fff;
      padding: 0.18rem 0.15rem;
    }
    .content-detail p:not(:last-child) {
      margin-bottom: 0.1rem;
    }
    .content-reason {
      padding: 0rem 0.15rem;
      .content-reasonItem {
        display: flex;
        justify-content: space-between;
        height: 0.55rem;
        line-height: 0.55rem;
        border-bottom: 1px solid #e5e5e5;
      }
      .content-reasonItem:not(:last-child) {
        border-bottom: 1px solid #e5e5e5;
      }
    }
    .sub_btn {
    }
    .success_btn {
      background-color: #07c160;
    }
    .CANCEL,
    .OUTTIME_AUDIT {
      color: rgba(51, 51, 51, 0.5);
    }
    .WAITING_AUDIT,
    .WAITING_VERIFY {
      color: #f2b230;
    }
    .OUTTIME_VISIT {
      color: #f76260;
    }
    .FINISH {
      color: #3b86ff;
    }

    .btns {
      display: flex;
      justify-content: center;
    }

    .tips {
      display: flex;
      flex-direction: column;
      font-size: 0.12rem;
      color: #ffbe00;
      line-height: 0.24rem;
      margin-left: 30px;
      padding-bottom: 30px;
    }
  }
  .van-field__control{
    text-align: left;
  }
}
.content-detail:not(:last-child) {
  border-bottom: 1px solid rgba(229, 229, 229, 1);
}

.stall_tip{
  padding: 0 0.15rem;
  font-size: 0.14rem;
  color: #888;
  margin-top: 0.1rem;
}
</style>
